module.exports = __webpack_public_path__ + "static/media/Deer_2_t.6aa95ec3.jpg";